import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import React from "react";
import { useForm } from 'react-hook-form'
import API from "../../services/api";
import { Toast } from "../../shared/Toast";


function EventEngagement(props) {
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
            event.preventDefault();
        }
    }

    const handleClose = () => {
        props.setShow(false)
    }
    const onSubmit = async (data) => {
        try {
            let res = await API({
                url: 'sales_contacts/event_engagement',
                method: 'POST',
                responseType: 'json',
                data: {
                    ...data,
                    contact_id: props.details?.contact_id
                }
            })
            if (res.code === 200) {
                Toast('success', 'Engagement recorded successfully!')
                reset()
                handleClose()

            }
            else {
                Toast('error', res.data?.message)
            }
        } catch (error) {
            console.error(error)
        }
    }
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({ mode: "onTouched" });
    return (
        <>
            <SlDrawer open={props.show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} label="Event Engagement">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <label className="form-label">Enter Engagement Name</label>
                        <input className="form-control" {...register('engagement_name', { required: true })} placeholder="Enter Event name"></input>
                        {errors.event_name && <p className="text-red-600">Please Enter Engagement Name</p>}

                    </div>
                    <div className="mb-3">
                        <label className="form-label">Enter Date</label>
                        <input type="date" className="form-control" {...register('date', { required: true })} />
                        {errors.date && <p className="text-red-600">Please choose date</p>}

                    </div>
                    <div className="mb-3">
                        <label className="form-label">Enter Description</label>
                        <textarea className="form-control" placeholder="Enter Description" {...register('description', { required: true })}></textarea>
                        {errors.description && <p className="text-red-600">Please Enter Description</p>}
                    </div>
                    <button type="submit" className="btn btn-primary">
                        Submit
                    </button>
                </form>
            </SlDrawer>
        </>
    )
}


export default EventEngagement;